<section class="settings">
  <section class="settings__nav">
    <span class="settings__nav-wrapper" (click)="moveBack()">
      <svg-icon src="assets/icons/arrow-grey.svg" class="settings__back-btn"></svg-icon>
      <span class="settings__nav-title" [translate]="'settings.back-button'"></span>
    </span>
  </section>

  <app-settings-tabs class="settings__tabs" [currentTab]="currentTab"
                     (tabSelected)="onTabSelectHandler($event)"></app-settings-tabs>

  <div class="settings__settings-container settings-container">
    <div class="settings-container__header header">
      <div *ngIf="currentTab === 'settings'" class="header__title" [translate]="'settings.title'"></div>
      <div *ngIf="currentTab === 'notifications'" class="header__title" [translate]="'settings.notifications.title'"></div>
      <div class="header__hr">
        <hr />
      </div>
    </div>
    <app-general-settings *ngIf="currentTab === 'settings'"></app-general-settings>
    <app-notifications *ngIf="currentTab === 'notifications'"></app-notifications>
  </div>

  <section class="settings__link-container">
    <a [href]="termsOfServiceLink" class="settings__link" target="_blank"
       [translate]="'settings.general-terms-link'"></a>
  </section>

  <section class="settings__rights">
    <div>© {{year}} {{companyName}} | All rights reserved</div>
    <div>Version: {{version}}</div>
  </section>

  <div *ngIf="isLoading" class="panel">
    <app-loader></app-loader>
  </div>
</section>
